import { ActGlo, ActDoc } from '../App_Data/ActionTypes';

const initialState = {
    Docs: ActGlo.EN_COURS_DE_CHARGEMENT,
    Filtres: {
        Objet: '',
        Prest: '',
        Act: '',
    },
};

function DocStore(state = initialState, action) {
    switch (action.type) {
    case ActGlo.RESET_STORE:
    case ActGlo.CHANGE_COP_SEL:
        return initialState;
    case ActDoc.DOC_AJOUT:
        return {
            ...state,
            Docs: action.data,
        };
    case ActDoc.DOC_FILTRE_OBJET:
        return {
            ...state,
            Filtres: {
                ...state.Filtres,
                Objet: action.data,
            },
        };
    case ActDoc.DOC_FILTRE_PREST:
        return {
            ...state,
            Filtres: {
                ...state.Filtres,
                Prest: action.data,
            },
        };
    case ActDoc.DOC_FILTRE_ACT:
        return {
            ...state,
            Filtres: {
                ...state.Filtres,
                Act: action.data,
            },
        };
    case ActDoc.DOC_FILTRES_SUPPR:
        return {
            ...state,
            Filtres: initialState.Filtres,
        };
    default:
        return state;
    }
}

export default DocStore;



// WEBPACK FOOTER //
// ./src/Reducers/DocStore.js